import React from 'react';
import { Flex } from '@chakra-ui/react';
import { LanguageIcon } from '@udacity/chakra-uds-icons';
import { useTranslation } from 'react-i18next';
import { ColorTag } from 'app/common/components/color-tag/color-tag';
import { getSubmissionLanguageI18nKey } from 'app/helpers/submission-helper';

type LanguageTagProps = {
  languageCode: string;
};

export const LanguageTag: React.FC<LanguageTagProps> = ({ languageCode }) => {
  const { t } = useTranslation();
  return (
    <ColorTag variant="gray">
      <Flex as="span" display="inline-flex" alignItems="center">
        <LanguageIcon aria-hidden="true" color="gray.500" h="4" w="4" />
        {t(getSubmissionLanguageI18nKey(languageCode))}
      </Flex>
    </ColorTag>
  );
};
